import { CustomPlaylist } from "@/app/modules/Playlists";
import { useParams } from "react-router-dom";

export const Playlist = () => {
  const { id } = useParams();
  if (!id) {
    return null;
  }
  return <CustomPlaylist playlistId={parseInt(id)} />;
};
